module.exports = __webpack_public_path__ + "img/nsu.3887cc57.png";